// Helper para destacar tarifas del agregador Epak (pak2go) en todos los
// cotizadores de la app. Centraliza la regla para mantenerla consistente.
export const FEATURED_SOURCES = ["pak2go"];

export function isFeaturedRate(rate) {
  return !!rate && FEATURED_SOURCES.includes(rate.source);
}

// Clases Tailwind reutilizables para el destacado visual (acento violeta/fucsia).
export const FEATURED_CARD_CLS = "border-violet-500/70 bg-violet-500/[0.07] shadow-[0_0_0_1px_hsl(265_89%_78%/0.4),0_0_18px_hsl(265_89%_78%/0.22)]";
export const FEATURED_ROW_CLS = "border-l-2 border-violet-500 bg-violet-500/[0.06]";